/* src/app/views/template/components/templates/web/web-templates-container/web-templates-container.component.scss */
/*# sourceMappingURL=web-templates-container.component.css.map */
